module.exports = __webpack_public_path__ + "img/field_3.82265ca3.jpg";